import { render, staticRenderFns } from "./RetailCreate.vue?vue&type=template&id=6b41f3bf"
import script from "./RetailCreate.vue?vue&type=script&lang=js"
export * from "./RetailCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports